/**
 * Workout completions (client view) – create completion, list by client.
 */
import {
  collection,
  doc,
  getDoc,
  getDocs,
  addDoc,
  query,
  where,
  orderBy,
  limit,
} from 'firebase/firestore';
import { db } from '../firebase/config';

const COLLECTION = 'workoutCompletions';

export async function getByAssignedWorkout(assignedWorkoutId, clientId) {
  if (!assignedWorkoutId || !clientId) throw new Error('assignedWorkoutId and clientId are required');
  const q = query(
    collection(db, COLLECTION),
    where('assignedWorkoutId', '==', assignedWorkoutId),
    where('clientId', '==', clientId),
    limit(1)
  );
  const snap = await getDocs(q);
  if (snap.empty) return null;
  const d = snap.docs[0];
  return { id: d.id, ...d.data() };
}

export async function create(data) {
  const ref = await addDoc(collection(db, COLLECTION), {
    ...data,
    completedAt: data.completedAt || new Date(),
    createdAt: new Date(),
  });
  return ref.id;
}

export async function listByClient(clientId, limitCount = 500) {
  const q = query(
    collection(db, COLLECTION),
    where('clientId', '==', clientId),
    orderBy('completedAt', 'desc'),
    limit(limitCount)
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export const workoutCompletionRepo = {
  getByAssignedWorkout,
  create,
  listByClient,
};
